import { type RefObject, useEffect } from 'react';

export function useFocusShortcut(key: string, ref: RefObject<HTMLElement | null>): void {
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key !== key || e.metaKey || e.ctrlKey || e.altKey) return;
      if (e.repeat) return;
      const el = document.activeElement as HTMLElement | null;
      const isEditing =
        el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement || (el?.isContentEditable ?? false);
      if (isEditing) return;
      e.preventDefault();
      ref.current?.focus();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [key, ref]);
}
